// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockContainer_root__2N28U"};